import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import React from "react";

export const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    arrow
    classes={{ popper: className }}
    placement="top"
    disableInteractive
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.warning.light,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.warning.light,
    fontSize: theme.typography.pxToRem(14),
  },
}));
